import { getAllDocuments } from 'entities/orderAttachments/api/getAllDocuments'
import { deleteDocumentFromOrder } from 'entities/orderAttachments/api/deleteDocumentFromOrder'
import { addDocumentsToOrder } from 'entities/orderAttachments/api/addDocumentsToOrder'
import { getArchiveOfAllDocuments } from 'entities/orderAttachments/api/getArchiveOfAllDocuments'

export const AttachmentsApi = {
    getAllDocuments,
    addDocumentsToOrder,
    deleteDocumentFromOrder,
    getArchiveOfAllDocuments,
}
